import { withNestedView } from '@/router/routerHelpers';
import { FEATURES } from '@/access/features';
const loadView = withNestedView('tasks');

const tasksRoutes = [
  {
    path: '/tasks',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: FEATURES.TASKS,
    },
    children: [
      {
        path: ':slug?',
        name: 'tasks',
        meta: { showNav: true, feature: FEATURES.TASKS },
        props: true,
        component: loadView('Tasks'),
      },
    ],
  },
];

export default tasksRoutes;
